export default __webpack_public_path__ + "static/media/1014.6ce18f47.png";